import EpisodesTable from './EpisodesTable';

export default EpisodesTable;
